import React from 'react';

import { useTranslation } from '@crehana/i18n';

const PaymentDisclaimer: React.FC<{
  className?: string;
  totalToPayInDollars?: number | null;
}> = ({ className, totalToPayInDollars }) => {
  const { t } = useTranslation();

  return (
    <p
      className={`font-legals text-base-main md:text-secondary-dark ${className}`}
    >
      {t('PAYMENT_DISCLAIMER', { interpolation: { totalToPayInDollars } })}
    </p>
  );
};

export default PaymentDisclaimer;
